module.exports = __webpack_public_path__ + "static/ResumePraffulKumar-d74df86316e236aa4a6f26bbe91b65ec.pdf";